{
  "version": 1,
  "asset_id": "6e8b536c-2549-4d53-90e4-524685655b5a",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/6e8b536c-2549-4d53-90e4-524685655b5a/hiatal-type-4-v3-800.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/6e8b536c-2549-4d53-90e4-524685655b5a/hiatal-type-4-v3-800.jpg",
  "original_filename": "hiatal-type-4-v3-800.jpg",
  "size": 129519,
  "content_type": "image/jpeg",
  "created_at": "2026-10-28T23:03:50Z"
}
